import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';

export class StandardTestResultsBuildPart extends BaseBuildPart {
    constructor(private readonly standardTestResultsHelperParams: HelperParams,
                parent: BaseBuildPart,
                tab?: string) {
        super(standardTestResultsHelperParams, parent, StandardTestResultsBuildPart.getPaths(tab));
    }

    public testResults() {
        return new BaseBuildPart(this.standardTestResultsHelperParams, this, ['test-results']);
    }

    public trends() {
        return new BaseBuildPart(this.standardTestResultsHelperParams, this, ['trends']);
    }

    public boxplots() {
        return new BaseBuildPart(this.standardTestResultsHelperParams, this, ['boxplots']);
    }

    private static getPaths(tab?: string) {

        const paths = ['standard-test-results'];

        if (tab) {
            paths.push(tab);
        }

        return paths;
    }
}